import { Tooltip } from "primereact/tooltip";

const SfTooltip = (props) => {
  const classes = props.styling ? props.styling : "";

  return <Tooltip {...props} className={classes} />;
};

export default SfTooltip;
